import Typography from "components/styled/Typography"
import { Container, TitleWrapper } from "components/styled/Grid"
import Suggestions from "../Suggestions";

export default function Kinds() {

  return (
    <Container top={50} bottom={50}>
      <TitleWrapper>
        <Typography variant="title2" weight="medium" center space>
          Elige un renting a tu medida
        </Typography>
        <Typography center space>
          La mejor solución de movilidad para profesionales
        </Typography>
      </TitleWrapper>
      <Suggestions types={["new", "commercial", "company", "pre_owned"]} page="freelance" />
    </Container>
  )
}
